<template lang="pug">
    div
        v-btn(
            v-if="filters && (filters.length > 0 || !noSearchBox)"
            :color="colors.primary" 
            dark
            @click="show = !show"
        )
            v-icon(left) search
            span Búsqueda
        div(v-if="show")
            v-layout(row wrap)
                v-flex.xs12.md6.px-3(v-if="!noSearchBox")
                    data-table-searchbox(
                        v-model="search"
                        @search="$emit('search', search)"
                        )
                template(v-for="filter in filters")
                    v-flex.xs12.md6.px-3(:key="filter.field" style="display: flex; justify-content: center;")
                        div(v-if="filter.type === 'checkbox'")
                            v-checkbox(
                                :label="filter.label"
                                v-model="vmodels[filter.field]"
                                @change="handleChange(filter)"
                                )
                        v-text-field(
                            v-else-if="!filter.options"
                            :label="filter.label"
                            v-model="vmodels[filter.field]"
                            @keyup.enter='applyFilter'
                        )
                        v-select(
                            v-else-if="filter.options && filter.options.length > 0"
                            v-model="vmodels[filter.field]"
                            v-bind='filter.props'
                            :items="filter.options"
                            multiple
                            :label="filter.label"
                            chips
                            @change="handleChange(filter)"
                        )
                v-flex.px-3.xs12.md6(v-if="!filterOnChange")
                    v-btn(block :color="colors.primary" dark large @click="applyFilter()") Filtrar
                v-flex.px-3.xs12(:class="buttonsLayout" )
                    v-btn(block :color="colors.primary" outline large @click="clearFilters()") Limpiar
</template>

<script>
import { objectIsEmpty } from '@/services/JSUtils.js'
import DataTableSearchbox from './DataTableSearchbox'
export default {
    name: 'data-table-filters',
    props: {
        /**
         * @description
         * Filters to be showed
         */
        filters: {
            type: Array,
            default: () => [],
        },
        filterOnChange: {
            type: Boolean,
            default: () => true,
        },
        /**
         * @description
         */
        noSearchBox: {
            type: Boolean,
            default: () => false,
        },
    },
    data: function() {
        return {
            show: false,
            vmodels: {},
            search: '',
        }
    },
    computed: {
        /**
         * @description
         */
        buttonsLayout: function() {
            let fieldsNumber = this.filters.length
            if (!this.noSearchBox) fieldsNumber++
            //if(!filterOnChange) fieldsNumber ++
            let clearButton = {}
            if (!this.filterOnChange) {
                if (fieldsNumber % 2 === 0) clearButton.md6 = true
            } else {
                if (fieldsNumber % 2 !== 0) clearButton.md6 = true
            }
            return clearButton
        },
    },
    methods: {
        setVmodels: function() {
            let vmodels = {}
            this.filters.forEach(filter => {
                vmodels[filter.field] = filter.value
                console.log(filter.value, 'filtervalue')
            })
            this.vmodels = { ...vmodels }
        },
        applyFilter: function() {
            let vmodels = { ...this.vmodels }
            const filters = []
            for (const key in vmodels) {
                if (vmodels.hasOwnProperty(key)) {
                    let val = vmodels[key]
                    if (typeof val === 'string') {
                        val = val.trim()
                        if (val != '') {
                            val = [val]
                            let filter = {}
                            ;(filter.field = key), (filter.value = val)
                            filters.push(filter)
                        }
                    } else if (
                        (val.constructor === Array && val.length > 0) ||
                        typeof val === 'boolean'
                    ) {
                        let filter = {}
                        filter.field = key
                        filter.value = val
                        filters.push(filter)
                    }
                }
            }
            this.$emit('filter', filters)
        },
        handleChange: function(filter) {
            if (this.filterOnChange) {
                this.applyFilter()
            }
        },
        clearFilters() {
            this.search = ''
            this.vmodels = {}
            this.$emit('search', this.search)
            this.applyFilter()
            this.setVmodels()
        },
        test(e) {
            console.log(e)
        },
    },
    watch: {
        /**
         * @description
         * Listen to filters changes to
         */
        filters: {
            handler: function() {
                if (!objectIsEmpty(this.vmodels)) return
                this.setVmodels()
            },
            deep: true,
        },
        show: function(){
            this.$emit('filters:show', this.show)
        }
    },
    components: {
        'data-table-searchbox': DataTableSearchbox,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: function() {
        this.setVmodels()
    },
    // mounted: function(){},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>